module.exports = __webpack_public_path__ + "static/HIW2-41311cce6464a846b68a229d5c2813aa.svg";